import { Card } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { AddressCard } from '~src/pages/shipment/details/address-card';

import { ShipmentTemplateDetails } from '../types';

interface Props {
  template: ShipmentTemplateDetails;
}

export function Addresses({ template }: Props) {
  const { t } = useTranslation();

  if (!template.contact_from && !template.contact_to && !template.customer_info?.contact && !template.contact_return) {
    return null;
  }

  return (
    <Card.List>
      <Card.Wrapper>
        <Card.Header>{t('common.addresses')}</Card.Header>
        <Card.Grid css={{ width: '640px' }}>
          <AddressCard label="shipments.address.type.contact_from" address={template.contact_from?.address} />
          <AddressCard
            label="shipments.address.type.customer_info.contact"
            address={template.customer_info?.contact?.address}
            email={template.customer_info?.contact?.email}
            phone={template.customer_info?.contact?.phone}
          />
          <AddressCard label="shipments.address.type.contact_return" address={template.contact_return?.address} />
          <AddressCard label="shipments.address.type.contact_to" address={template.contact_to?.address} />
        </Card.Grid>
      </Card.Wrapper>
    </Card.List>
  );
}
